import { useEffect as r } from "react";
function c(e, n) {
  const t = (o) => {
    e.current && !e.current.contains(o.target) && n();
  };
  r(() => (document.addEventListener("mousedown", t), () => {
    document.removeEventListener("mousedown", t);
  }), [e]);
}
export {
  c as useOutsideClick
};
//# sourceMappingURL=useOutsideClick.es.js.map
